import axios from 'axios';
import {
  ClientPlatform,
  ClientUpdateRequiredPayload,
} from '../types/clientUpdate';

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

const asOptionalString = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
};

const parsePlatform = (value: unknown): ClientPlatform => {
  if (value === 'ios' || value === 'android' || value === 'web') {
    return value;
  }

  return 'web';
};

export const parseClientUpdateRequiredPayload = (
  value: unknown
): ClientUpdateRequiredPayload | null => {
  if (!isRecord(value)) {
    return null;
  }

  if (value.code !== 'CLIENT_UPDATE_REQUIRED') {
    return null;
  }

  const minimum = isRecord(value.minimum) ? value.minimum : {};
  const actions = isRecord(value.actions) ? value.actions : {};

  const buildVersion =
    asOptionalString(minimum.buildVersion) ??
    asOptionalString(minimum.webBuild);

  return {
    code: 'CLIENT_UPDATE_REQUIRED',
    message:
      typeof value.message === 'string' && value.message.trim().length > 0
        ? value.message
        : 'A new version is required.',
    platform: parsePlatform(value.platform),
    minimum: {
      buildVersion,
    },
    actions: {
      hardRefresh: actions.hardRefresh === true,
    },
  };
};

export const isClientUpdateRequiredError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) {
    return false;
  }

  if (error.response?.status === 426) {
    return true;
  }

  return parseClientUpdateRequiredPayload(error.response?.data) !== null;
};
